export default () => {
  // Setup constants.
  const NAME = 'accessibility-high-contrast';
  const COOKIE = document.documentElement.getAttribute('data-namespace') + NAME;
  const VARIABLES = {
    'primary': '#000',
    'primary-bg': '#fff',
    'primary-dark': '#000',
    'primary-light': '#000',
    'secondary': '#000',
    'secondary-bg': '#fff',
    'secondary-dark': '#000',
    'secondary-light': '#000',
    'tertiary': '#000',
    'tertiary-bg': '#fff',
    'tertiary-dark': '#000',
    'tertiary-light': '#000',
    'quaternary': '#000',
    'quaternary-bg': '#fff',
    'quaternary-dark': '#000',
    'quaternary-light': '#000',
    'quinary': '#000',
    'quinary-bg': '#fff',
    'quinary-dark': '#000',
    'quinary-light': '#000',
    'senary': '#000',
    'senary-bg': '#fff',
    'senary-dark': '#000',
    'senary-light': '#000'
  };
  const SELECTION = '*::selection{color:#fff;background-color:#000;}';

  // Setup state.
  let isEnabled = false;

  // Setup style element.
  const styleElement = window.document.createElement('style');
  styleElement.setAttribute('data-source', NAME);
  window.document.head.appendChild(styleElement);
  let buttons = [];
  const updateButtonState = () => {
    for (const button of buttons) {
      button.setAttribute('aria-pressed', isEnabled ? 'true' : 'false');
    }
  };
  onInteractive(() => {
    buttons = Array.from(document.querySelectorAll('.accessibility-contrast-toggle'));
    updateButtonState();
  });

  // Define private methods.
  const updateHighContrast = function () {
    if (isEnabled) {
      let styling = ':root {';
      for (const variableName in VARIABLES) {
        styling += '--' + variableName + ':' + VARIABLES[variableName] + ';';
      }
      styling += '}' + SELECTION;
      styleElement.innerText = styling;
      window.document.body.setAttribute('data-' + NAME, 'true');
    } else {
      // Remove styling.
      styleElement.innerText = '';
      window.document.body.removeAttribute('data-' + NAME);
    }

    // Update in cookies.
    if (window.util && window.util.cookies) {
      if (isEnabled) {
        window.util.cookies.set(COOKIE, 'true');
      } else if (window.util.cookies.has(COOKIE)) {
        window.util.cookies.delete(COOKIE);
      }
    }
    updateButtonState();

    // Dispatch change event.
    window.document.body.dispatchEvent(new CustomEvent('accessibility-high-contrast-changed', {
      detail: {
        isEnabled: isEnabled
      }
    }));
  };

  // Define public methods.
  const disableHighContrast = function () {
    if (!isEnabled) {
      return;
    }
    isEnabled = false;
    updateHighContrast();
  };
  const enableHighContrast = function () {
    if (isEnabled) {
      return;
    }
    isEnabled = true;
    updateHighContrast();
  };
  const toggleHighContrast = function () {
    isEnabled = !isEnabled;
    updateHighContrast();
  };

  // Set initial state from cookie.
  if (window.util && window.util.cookies) {
    isEnabled = window.util.cookies.has(COOKIE);
    updateHighContrast();
  }

  // Make globally available.
  const accessibility = {
    disableHighContrast: disableHighContrast,
    enableHighContrast: enableHighContrast,
    toggleHighContrast: toggleHighContrast
  };
  if (window.accessibility) {
    window.accessibility = Object.assign(window.accessibility, accessibility);
  } else {
    window.accessibility = accessibility;
  }
};